import { render, staticRenderFns } from "./StudentsViewTabGeneralData.vue?vue&type=template&id=11e1ec80"
import script from "./StudentsViewTabGeneralData.vue?vue&type=script&lang=js"
export * from "./StudentsViewTabGeneralData.vue?vue&type=script&lang=js"
import style0 from "./StudentsViewTabGeneralData.vue?vue&type=style&index=0&id=11e1ec80&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports